import React, { useEffect } from 'react';
import { useQuery } from 'react-query';
import { Link } from 'react-router-dom';

import { Box, ButtonBase, Grid, Typography } from '@material-ui/core';

import { ReactComponent as RightIcon } from '../../../assets/img/icon/Right.svg';
import SubHeader from '../../../components/Header/SubHeader.component';
import Loader from '../../../components/LoaderSplash/Loader.component';
import SuraCard from '../../../components/SuraCard';
import { useSelfInspectionDataContext } from '../../../context/SelfInspection/selfInspection.provider';
import { useAuthDataContext } from '../../../context/auth/auth.provider';
import { useIncidentsContext } from '../../../context/incidents/incidents.provider';
import { dataLayerPush } from '../../../helpers/dataLayerPush';
import {
  SINISTER_INSPECTION_QUERY,
  sinisterInspectionsQuery,
} from '../../../query/sinisterInspections/sinisterInspections';

const InspectionsWrapped = () => {
  //const { loading } = useSelfInspectionDataContext();
  //const { incident, getIncidentById } = useIncidentsContext();
  const { user } = useAuthDataContext();

  // const { data: incidents, isLoading: loading } = useQuery(
  //   SINISTER_INSPECTION_QUERY,
  //   sinisterInspectionsQuery,
  //   {}
  // );

  useEffect(() => {
    dataLayerPush('Inspecciones', user?.id);
  }, [user]);

  return (
    <>
      <SubHeader
        content={<Typography variant="h6">Coordinar una inspección</Typography>}
      ></SubHeader>

      {/* <Grid container justify={"center"} style={{ marginTop: "36px" }}>
        <Grid item xs={11} md={8} lg={6}>
          <Grid container>
            <Grid item xs={12}>
              <Link to="/inspections/previous">
                <SuraCard>
                  <Box
                    m={2}
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    width="100%"
                  >
                    <Box
                      display="flex"
                      justifyContent="space-between"
                      alignItems="flex-start"
                      flexDirection="column"
                    >
                      <Box textAlign="left">
                        <Typography
                          display="inline"
                          variant="subtitle1"
                          color="primary"
                        >
                          Inspecciones previas
                        </Typography>
                      </Box>
                    </Box>
                    <Box>
                      <RightIcon></RightIcon>
                    </Box>
                  </Box>
                </SuraCard>
              </Link>
            </Grid>
          </Grid>
        </Grid>
      </Grid> */}

      <Grid container justify={'center'} style={{ marginTop: '36px' }}>
        <Grid item xs={11}>
          <Grid container>
            <Grid item xs={12}>
              <ButtonBase
                component={Link}
                to={'/sinister-inspections'}
                style={{ width: '100%' }}
              >
                <SuraCard>
                  <Box
                    m={2}
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    width="100%"
                  >
                    <Box
                      display="flex"
                      justifyContent="space-between"
                      alignItems="flex-start"
                      flexDirection="column"
                    >
                      <Box textAlign="left">
                        <Typography display="inline" variant="h6">
                          Inspecciones por siniestros
                        </Typography>
                      </Box>
                    </Box>
                    <Box>
                      <RightIcon></RightIcon>
                    </Box>
                  </Box>
                </SuraCard>
              </ButtonBase>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default InspectionsWrapped;
